import { jsx } from "react/jsx-runtime";
import ArrowForwardIosSharp from "@mui/icons-material/ArrowForwardIosSharp";
import {
  accordionSummaryClasses,
  AccordionSummary as MuiAccordionSummary,
  styled
} from "@mui/material";
const AccordionSummary = styled((props) => /* @__PURE__ */ jsx(MuiAccordionSummary, { expandIcon: /* @__PURE__ */ jsx(ArrowForwardIosSharp, { sx: { fontSize: "0.9rem" } }), ...props }))(({ theme }) => ({
  alignItems: "center",
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  justifyContent: "center",
  marginLeft: 1,
  marginRight: 1,
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    transform: "rotate(90deg)"
  },
  [`& .${accordionSummaryClasses.content}`]: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: theme.spacing(1)
  }
}));
export {
  AccordionSummary
};
//# sourceMappingURL=AccordionSummary.js.map
